// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-toolbar.v-toolbar--dense.view-toolbar {\n  height: 36px !important;\n}\n.v-toolbar.v-toolbar--dense.view-toolbar .v-toolbar__content {\n  height: 36px !important;\n}\n.v-toolbar.v-toolbar--dense.view-toolbar .v-toolbar__title {\n  font-size: 1.15rem;\n  line-height: 1.3;\n}\n\n/* custom styles */", ""]);
// Exports
module.exports = exports;
